import { useTranslation } from "react-i18next";

import {
  PASSWORD_COMPLEXITY_MIN_LENGTH,
  PASSWORD_COMPLEXITY_REGEX,
  yupLocalized,
} from "@ryde/shared";

export const useYupResetPasswordValidationSchema = () => {
  const { t } = useTranslation();

  const yupResetPasswordValidationSchema = yupLocalized
    .object()
    .shape({
      password: yupLocalized
        .string()
        .required(t("validation.required", { path: t("ui.PASSWORD") }))
        .matches(
          PASSWORD_COMPLEXITY_REGEX,
          t("validation.passwordComplexity", {
            path: t("ui.PASSWORD"),
            min: PASSWORD_COMPLEXITY_MIN_LENGTH,
          }),
        ),
      repeatPassword: yupLocalized
        .string()
        .required(t("validation.required", { path: t("ui.REPEAT_PASSWORD") }))
        .matches(
          PASSWORD_COMPLEXITY_REGEX,
          t("validation.passwordComplexity", {
            path: t("ui.REPEAT_PASSWORD"),
            min: PASSWORD_COMPLEXITY_MIN_LENGTH,
          }),
        ),
    })
    .required();

  return {
    yupResetPasswordValidationSchema,
  };
};
